import React, { type FC } from "react";

import { Row } from "~/components/canvas/layout/row/Row";

import { useEaselCurrentPage } from "../hooks/useEaselCurrentPage";
import { PageTitle } from "./PageTitle";

type EditorHeaderProps = {
	writable: boolean;
};

/**
 * <EditorHeader/>
 * Displays the header of a canvas—title, author, date published, and so on.
 */
export const EditorHeader: FC<EditorHeaderProps> = ({ writable }) => {
	// Hooks
	const page = useEaselCurrentPage();

	return (
		page && (
			<div className="rich-text mt-10 @lg/main:mt-10 @xl/main:mt-10 flex flex-col">
				<Row>
					<PageTitle page={page} writable={writable} />
				</Row>
			</div>
		)
	);
};
